import React from "react";
import SEO from "../components/SEO";

const css = `
:root {
 --blue:    #2563EB;
 --blue-d:  #1D4ED8;
 --blue-l:  #EFF6FF;
 --dark:    #0A1628;
 --mid:     #1E3A5F;
 --gray:    #475569;
 --lgray:   #64748B;
 --xlgray:  #94A3B8;
 --border:  #E2E8F0;
 --off:     #F8FAFC;
 --white:   #FFFFFF;
}
.tos-page *,.tos-page *::before,.tos-page *::after { box-sizing:border-box; margin:0; padding:0 }
.tos-page { font-family:'Inter',sans-serif; background:var(--off); color:var(--dark); line-height:1.7; font-size:16px; -webkit-font-smoothing:antialiased; }
.tos-page .site-header { background: rgba(255,255,255,.96); border-bottom: 1px solid var(--border); padding: 18px 24px; position: sticky; top:0; z-index:50; backdrop-filter: blur(12px); }
.tos-page .header-inner { max-width: 880px; margin:0 auto; display:flex; align-items:center; justify-content:space-between; gap:16px; }
.tos-page .brand img { height:36px; display:block }
.tos-page .back-link { font-size:13px; font-weight:600; color:var(--gray); text-decoration:none; display:flex; align-items:center; gap:6px; transition: color .15s; }
.tos-page .back-link:hover { color:var(--blue) }
.tos-page .back-link svg { width:14px; height:14px }
.tos-page .doc-hero { background: var(--off); border-bottom: 1px solid var(--border); padding: 160px 24px 40px; }
.tos-page .doc-hero-inner { max-width:880px; margin:0 auto }
.tos-page .doc-eyebrow { display:inline-block; font-size:11px; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:var(--blue); margin-bottom:14px; }
.tos-page .doc-hero h1 { font-size:clamp(28px, 4vw, 40px); font-weight:800; letter-spacing:-.5px; line-height:1.15; color:var(--dark); margin-bottom:14px; }
.tos-page .doc-meta { display:flex; gap:24px; flex-wrap:wrap; font-size:13.5px; color:var(--lgray); }
.tos-page .doc-meta strong { color:var(--dark); font-weight:600 }
.tos-page .doc-body { max-width: 720px; margin: 0 auto; padding: 56px 24px 80px; }
.tos-page .doc-body p, .tos-page .doc-body li { font-size: 15.5px; color: var(--gray); line-height: 1.75; }
.tos-page .doc-body p { margin-bottom: 18px }
.tos-page .doc-body strong { color: var(--dark); font-weight:600 }
.tos-page .doc-body h2 { font-size: 22px; font-weight: 700; color: var(--dark); letter-spacing: -.2px; margin: 44px 0 16px; padding-bottom: 12px; border-bottom: 1px solid var(--border); scroll-margin-top: 90px; }
.tos-page .doc-body h2:first-child { margin-top: 0 }
.tos-page .doc-body ul { margin: 0 0 18px 22px }
.tos-page .doc-body li { margin-bottom: 8px }
.tos-page .intro-block { background: var(--blue-l); border-left: 3px solid var(--blue); padding: 18px 22px; border-radius: 0 8px 8px 0; margin-bottom: 36px; }
.tos-page .intro-block p { margin:0; color:var(--mid); font-size:15px }
.tos-page .intro-block p:not(:last-child) { margin-bottom:10px }
.tos-page a.inline-link { color:var(--blue); text-decoration:underline; font-weight:500 }
.tos-page a.inline-link:hover { color:var(--blue-d) }
.tos-page footer.doc-footer { background: var(--dark); padding: 36px 24px 24px; }
.tos-page .foot-inner { max-width: 880px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; margin-bottom: 24px; }
.tos-page .foot-brand { display:flex; align-items:center; gap:10px; text-decoration:none }
.tos-page .foot-brand img { height: 26px; filter: brightness(0) invert(1); opacity: .75; }
.tos-page .foot-brand span { font-size:13px; color:rgba(255,255,255,.4) }
.tos-page .foot-links { display:flex; gap:22px; flex-wrap:wrap }
.tos-page .foot-links a { font-size:13px; color:rgba(255,255,255,.55); text-decoration:none; transition: color .15s; }
.tos-page .foot-links a:hover { color:#fff }
.tos-page .foot-bot { max-width: 880px; margin: 0 auto; border-top: 1px solid rgba(255,255,255,.08); padding-top: 18px; text-align: center; font-size: 12px; color: rgba(255,255,255,.4); }
@media(max-width:640px) {
 .tos-page .site-header { padding: 14px 18px }
 .tos-page .brand img { height:28px }
 .tos-page .doc-hero { padding: 130px 20px 28px }
 .tos-page .doc-body { padding: 36px 20px 60px }
 .tos-page .doc-body p, .tos-page .doc-body li { font-size: 15px }
 .tos-page .doc-body h2 { font-size: 19px; margin-top: 36px }
 .tos-page .foot-inner { flex-direction:column; align-items:flex-start; gap:14px }
 .tos-page .foot-links { gap: 16px }
}
`;

const Tos = () => {
  return (
    <div className="tos-page">
      <SEO
        title="Terms of Service"
        description="SmileReveal Terms of Service — the rules and conditions for using our platform."
      />
      <style>{css}</style>

      <section className="doc-hero">
        <div className="doc-hero-inner">
          <span className="doc-eyebrow">Legal</span>
          <h1>Terms of Service</h1>
          <div className="doc-meta">
            <span><strong>Effective Date:</strong> May 5, 2026</span>
            <span><strong>Last Updated:</strong> May 5, 2026</span>
          </div>
        </div>
      </section>

      <main className="doc-body">
        <div className="intro-block">
          <p>These Terms of Service ("Terms") govern your access to and use of the SmileReveal platform, website, and related services (collectively, the "Services") provided by SmileReveal, Inc. ("SmileReveal," "we," "our," or "us").</p>
          <p>By accessing or using the Services, you agree to be bound by these Terms. If you do not agree, do not use the Services.</p>
        </div>

        <h2 id="eligibility">1. Eligibility</h2>
        <p>The Services are intended for use by licensed dental practices and their authorized personnel. By using the Services, you represent that you are at least 18 years old and have the legal authority to bind the practice you represent to these Terms.</p>

        <h2 id="accounts">2. Accounts and Access</h2>
        <p>To use the Services, you must register an account and provide accurate, current information. You are responsible for:</p>
        <ul>
          <li>Maintaining the confidentiality of your login credentials</li>
          <li>All activity that occurs under your account</li>
          <li>Promptly notifying us of any unauthorized access or security breach</li>
        </ul>

        <h2 id="acceptable-use">3. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Services for any unlawful, harmful, or fraudulent purpose</li>
          <li>Upload content you do not have the right to use, including patient images without proper consent</li>
          <li>Reverse engineer, decompile, or attempt to extract the underlying technology</li>
          <li>Resell, sublicense, or share access with unauthorized parties</li>
          <li>Interfere with the security or operation of the Services</li>
        </ul>

        <h2 id="patient-content">4. Patient Content and Consent</h2>
        <p>You are solely responsible for obtaining all necessary patient consents before uploading or processing any patient images, likenesses, or related information through the Services. SmileReveal acts as a tool; the practice remains the responsible party under HIPAA and applicable law.</p>

        <h2 id="ip">5. Intellectual Property</h2>
        <p>All software, designs, trademarks, AI models, and content provided by SmileReveal are owned by SmileReveal or its licensors. You receive a limited, non-exclusive, non-transferable license to use the Services during your active subscription. No other rights are granted.</p>
        <p>Content you upload remains yours. You grant SmileReveal a limited license to process that content solely to provide the Services.</p>

        <h2 id="ai-output">6. AI-Generated Output</h2>
        <p>SmileReveal generates visual previews using artificial intelligence. These previews are illustrative simulations, not clinical guarantees, predictions, or representations of actual treatment outcomes. The practice is responsible for clinical judgment and patient communication.</p>

        <h2 id="payment">7. Fees and Payment</h2>
        <p>Paid plans are billed in advance based on the plan you select. Fees are non-refundable except as expressly stated. We may change pricing with reasonable notice.</p>

        <h2 id="trial">8. Free Trial</h2>
        <p>Free trials are offered at our discretion and are limited in duration. At the end of the trial, you may choose to subscribe to a paid plan or discontinue use. No payment is required to claim a free trial unless explicitly stated.</p>

        <h2 id="termination">9. Termination</h2>
        <p>You may cancel your account at any time. We may suspend or terminate your access if you violate these Terms, fail to pay applicable fees, or for any reason with reasonable notice. Upon termination, your right to use the Services ends immediately.</p>

        <h2 id="warranties">10. Disclaimers</h2>
        <p>The Services are provided <strong>"as is"</strong> and <strong>"as available."</strong> SmileReveal makes no warranties, express or implied, including merchantability, fitness for a particular purpose, or non-infringement. We do not warrant that the Services will be uninterrupted, error-free, or produce specific clinical or business outcomes.</p>

        <h2 id="liability">11. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, SmileReveal will not be liable for any indirect, incidental, consequential, or punitive damages, including lost profits, lost revenue, or lost data. Our total liability for any claim arising out of or relating to the Services will not exceed the fees paid by you to SmileReveal in the twelve (12) months preceding the claim.</p>

        <h2 id="indemnity">12. Indemnification</h2>
        <p>You agree to indemnify and hold harmless SmileReveal and its affiliates from any claims, damages, or expenses arising from your use of the Services, your content, or your violation of these Terms or applicable law, including any patient-consent-related claims.</p>

        <h2 id="privacy">13. Privacy</h2>
        <p>Use of the Services is also governed by our <a className="inline-link" href="/privacy">Privacy Policy</a>. Where Protected Health Information is involved, the executed Business Associate Agreement governs.</p>

        <h2 id="changes">14. Changes to These Terms</h2>
        <p>We may update these Terms from time to time. Material changes will be communicated through the Services or by email. Continued use after changes take effect constitutes acceptance of the updated Terms.</p>

        <h2 id="law">15. Governing Law and Disputes</h2>
        <p>These Terms are governed by the laws of the State of Delaware, USA, without regard to conflict-of-laws principles. Any disputes will be resolved in the state or federal courts located in Delaware, and you consent to that jurisdiction.</p>
      </main>

      <footer className="doc-footer">
        <div className="foot-inner">
          <a href="/" className="foot-brand">
            <img
              src="https://assets.cdn.filesafe.space/tKloRW99HBqpfyHkP2PZ/media/69b51709eba487b1413f9072.png"
              alt="SmileReveal"
            />
            <span>Exclusive offer for TIE partner practices</span>
          </a>
          <div className="foot-links">
            <a href="/">About SmileReveal</a>
            <a href="/hipaa">HIPAA Compliance</a>
            <a href="mailto:sales@smilereveal.io">Contact</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="/tos">Terms of Service</a>
          </div>
        </div>
        <div className="foot-bot">© 2026 SmileReveal. All rights reserved. Offer exclusively available through The Implant Engine partner program.</div>
      </footer>
    </div>
  );
};

export default Tos;
